var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "url(#paint0_linear_2:821)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8671 39.1667C21.9599 39.1667 22.1142 38.8241 21.8013 37.9603L19.1338 29.1816L39.6671 17",
    fill: "#04081F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8662 31.1384C23.5662 31.1384 23.8754 30.8182 24.2662 30.4384L27.9995 26.8082L23.3427 24",
    fill: "#05081E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3424 31.8537L34.6264 40.1904C35.9141 40.9009 36.8433 40.533 37.1641 38.9951L41.7573 17.3504C42.2274 15.465 41.0386 14.6096 39.8066 15.1689L12.8356 25.5688C10.9946 26.3073 11.0056 27.3345 12.5001 27.792L19.4214 29.9525L35.4451 19.8433C36.2016 19.3846 36.896 19.631 36.3262 20.1368",
    fill: "url(#paint1_linear_2:821)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2:821",
    x1: 37.352,
    y1: 9.352,
    x2: 23.352,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2:821",
    x1: 31.5099,
    y1: 26.1602,
    x2: 35.8797,
    y2: 36.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04081F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04081F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.85b55d6f.svg";
export { ForwardRef as ReactComponent };